import * as React from 'react';
import ReactModal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import SvgInline from '../SvgInline/SvgInline';
import Typography from '@latitude/typography';
import {
  StyledModalOverlay,
  StyledModalPanel,
  StyledModalHeader,
  StyledModalCloseButton,
  StyledModalGlobalStyle,
  StyledModalContent
} from './ModalRebrand.styled';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';

const COMPONENT_ID = 'modal-rebrand';

const Modal = ({ isOpen, onRequestClose, title, parentSelector, content, trackingId, width, maxWidth }) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;
  return (
    <>
      <StyledModalGlobalStyle className={componentIdentifier} />

      <ReactModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel={title}
        closeTimeoutMS={200}
        parentSelector={parentSelector}
        overlayElement={(props, contentEl) => (
          <StyledModalOverlay
            className={`${componentIdentifier}-modal-overlay`}
            {...props}
          >
            {contentEl}
          </StyledModalOverlay>
        )}
        contentElement={(props, children) => (
          <StyledModalPanel
            {...props}
            className={`${componentIdentifier}-modal-panel`}
            width={width}
            maxWidth={maxWidth}
          >
            {children}
          </StyledModalPanel>
        )}
      >
        <StyledModalHeader
          className={`${componentIdentifier}-header-container`}
        >
          <Typography.SH4 semibold>{title}</Typography.SH4>

          <StyledModalCloseButton
            onClick={onRequestClose}
            className={`${componentIdentifier}-btn-container`}
          >
            <SvgInline
              ariaLabel="Close"
              name="cross"
              style={{
                width: 25,
                height: 25
              }}
              strokeBlueBright
            />
          </StyledModalCloseButton>
        </StyledModalHeader>
        <StyledModalContent>
          <Typography.Body color={REBRAND_COLOR.INDIGO}>
            {content}
          </Typography.Body>
        
        </StyledModalContent>
      </ReactModal>
    </>
  );
};

export default Modal;
